module.exports = __webpack_public_path__ + "static/fonts/medium-monster.svg";